import { jsx as _jsx } from "react/jsx-runtime";
import { SearchModeMenuItems } from '#pplx/frontend/apps/ask/search-modes-menu/SearchModeMenuItems.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import React, { memo, useMemo } from 'react';
const SIDECAR_PRIMARY_SEARCH_MODES = [
    SearchMode.ASI,
    SearchMode.BROWSER_AGENT,
];
const PRIMARY_SEARCH_MODES = [
    SearchMode.ASI,
    SearchMode.RESEARCH,
    SearchMode.AGENTIC_RESEARCH,
];
const ASK_INPUT_OMITTED_MODES = [SearchMode.SEARCH];
export const AskInputPlusMenuSearchModes = memo(function AskInputPlusMenuSearchModes({ searchMode, onSearchModeSelect, omittedSearchModes: controlledOmittedSearchModes = EMPTY_ARRAY, tooltipMaxWidth, submenuMaxWidth, }) {
    const primaryModes = import.meta.env.VITE_IS_SIDECAR_BUILD
        ? SIDECAR_PRIMARY_SEARCH_MODES
        : PRIMARY_SEARCH_MODES;
    const omittedSearchModes = useMemo(() => [...ASK_INPUT_OMITTED_MODES, ...controlledOmittedSearchModes], [controlledOmittedSearchModes]);
    return (_jsx(SearchModeMenuItems, { searchMode: searchMode, onSearchModeSelect: onSearchModeSelect, omittedSearchModes: omittedSearchModes, tooltipMaxWidth: tooltipMaxWidth, submenuMaxWidth: submenuMaxWidth, primaryModes: primaryModes }));
});
//# sourceMappingURL=AskInputPlusMenuSearchModes.js.map